import { render } from "./IconPassword.vue?vue&type=template&id=4895e4b4"
const script = {}

import exportComponent from "E:\\salekWebApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__